import { render, staticRenderFns } from "./MatchingTeacher.vue?vue&type=template&id=155ac39e&scoped=true"
import script from "./MatchingTeacher.vue?vue&type=script&lang=js"
export * from "./MatchingTeacher.vue?vue&type=script&lang=js"
import style0 from "./MatchingTeacher.vue?vue&type=style&index=0&id=155ac39e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155ac39e",
  null
  
)

export default component.exports